import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SIZES, APPEARANCES, POSITION } from './constants';
import Icon from '../icon';

const FloatingAction = ({
  size = SIZES.large,
  appearance = APPEARANCES.accent,
  position = POSITION.default,
  disabled = false,
  onClick = Function.prototype,
}) => {
  const classes = classNames(
    'ws-ui-floating-action',
    `ws-ui-floating-action--${size}`,
    `ws-ui-floating-action--${appearance}`,
    `ws-ui-floating-action--${position}`,
    { 'ws-ui-floating-action--disabled': disabled }
  );

  return (
    <button className={classes} onClick={onClick}>
      <Icon glyph="plus-for-button" />
    </button>
  );
};

FloatingAction.propTypes = {
  size: PropTypes.oneOf(Object.values(SIZES)),
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  position: PropTypes.oneOf(Object.values(POSITION)),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default FloatingAction;
